import { PRODUCT_MODIFICATION_PROCESS_CLEAR_STATE } from "./constants";
import { productModificationProcessInitialState } from "./productModificationProcess";

const clear = (state: any) => {
	Object.assign(state, productModificationProcessInitialState());
};

const setProductModification = (state: any, productModification: any) => {
	state.productModification = productModification;
};

const setProductModificationShoppingCartId = (state: any, shoppingCartId: string) => {
	state.shoppingCartId = shoppingCartId;
};

const setProductModificationStatus = (state: any, status: string) => {
	state.status = status;
};

export default {
	[PRODUCT_MODIFICATION_PROCESS_CLEAR_STATE]: clear,
	setProductModification,
	setProductModificationShoppingCartId,
	setProductModificationStatus
};
